import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../axiosConfig";
import { ReportComponentsResponse } from "../../types/ReportTypes";

// Stocks requested from the Subiekt connector come back within a minute or so
const WAITING_REFETCH_INTERVAL = 5000;
// Keeps the connector status on the page up to date
const CONNECTOR_REFETCH_INTERVAL = 60000;

// Without report ID returns products waiting for the next report
export default function useGetReportComponents(
  reportId: number | null,
  enabled = true
) {
  return useQuery({
    queryKey: ["reportComponents", reportId],
    queryFn: async () => {
      return axiosInstance
        .get(`/reports/${reportId ?? "pending"}`)
        .then((res) => res.data);
    },
    enabled,
    select: (data: ReportComponentsResponse) => data,
    refetchInterval: (query) => {
      const connector = (query.state.data as ReportComponentsResponse | undefined)
        ?.connector;
      if (!connector?.enabled) {
        return false;
      }
      return connector.waitingCodes
        ? WAITING_REFETCH_INTERVAL
        : CONNECTOR_REFETCH_INTERVAL;
    },
    retry: false,
  });
}
